import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import TrackBooking from './pages/TrackBooking';
import BookingFlow from './pages/BookingFlow';
import Dashboard from './pages/Dashboard';
import About from './pages/About';
import DestinationsUK from './pages/DestinationsUK';
import DestinationsUS from './pages/DestinationsUS';
import SelectRoute from './pages/SelectRoute';
import Destinations from './pages/Destinations';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';

/**
 * Main App component for the BagABoard React application.
 * 
 * This component sets up the routing structure, authentication context,
 * and global components like navigation and notifications.
 * 
 * @author BagABoard Team
 */
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          {/* Navigation Bar */}
          <Navbar />

          {/* Main Content */}
          <main className="main-content" style={{ paddingTop: '80px', minHeight: 'calc(100vh - 200px)' }}>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/track" element={<TrackBooking />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<div className="container py-5"><h1>Contact Page - Coming Soon</h1></div>} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/uk" element={<DestinationsUK />} />
              <Route path="/destinations/united-states" element={<DestinationsUS />} />
              <Route path="/route-prices" element={<SelectRoute />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/terms-and-conditions" element={<Terms />} />

              {/* Private Routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />
              <Route path="/book" element={<BookingFlow />} />
              <Route path="/bookings" element={
                <PrivateRoute>
                  <div className="container py-5"><h1>My Bookings - Coming Soon</h1></div>
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <div className="container py-5"><h1>Profile - Coming Soon</h1></div>
                </PrivateRoute>
              } />
              <Route path="/booking-confirmation/:bookingId" element={
                <PrivateRoute>
                  <div className="container py-5"><h1>Booking Confirmation - Coming Soon</h1></div>
                </PrivateRoute>
              } />

              {/* 404 Not Found */}
              <Route path="*" element={
                <div className="container py-5">
                  <div className="row justify-content-center">
                    <div className="col-md-6 text-center">
                      <h1 className="display-1">404</h1>
                      <h2>Page Not Found</h2>
                      <p className="text-muted">The page you're looking for doesn't exist.</p>
                      <a href="/" className="btn btn-primary">Go Home</a>
                    </div>
                  </div>
                </div>
              } />
            </Routes>
          </main>

          {/* Footer */}
          <Footer />

          {/* Toast Notifications */}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
